import { Checkbox, Pagination } from 'antd';
import { useNavigate } from 'react-router-dom';
import NESTEDROUTE from 'utils/router';

type AbsenceTypeTableProps = {
  data: any;
  onChangeName: (value: string) => void;
  ref: any;
  onChange: (value: number) => void;
  itemRender: any;
  currentPage: number;
  count: number;
};
const AbsenceTypeTable = ({
  data,
  onChangeName,
  itemRender,
  onChange,
  currentPage,
  ref,
  count,
}: AbsenceTypeTableProps) => {
  const navigate = useNavigate();
  return (
    <div>
      <div
        style={{
          display: 'flex',
          gap: 20,
          width: '100%',
          borderBottom: '0.5px solid #73A1E7',
          height: 70,
          paddingBottom: 10,
        }}
      >
        <div
          style={{
            width: '15%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 600,
          }}
          className="staff_leave_type_text"
        >
          Active
        </div>
        <div
          style={{
            width: '85%',
            display: 'flex',
            flexDirection: 'column',
            paddingTop: '4px',
            fontWeight: 600,
          }}
          className="staff_leave_type_text"
        >
          Type
          <input
            ref={ref}
            onChange={(e) => onChangeName(e.target.value)}
            style={{ marginTop: '5px', width: '60%' }}
            className="common_custom_input_search"
          />
        </div>
      </div>
      {data?.length > 0 ? (
        data?.map((item) => (
          <div
            className="hoverCell"
            onClick={() =>
              navigate(NESTEDROUTE.staff_leave_types_detail, {
                state: { item: item },
              })
            }
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 20,
              width: '100%',
              borderBottom: '0.5px solid #73A1E7',
              height: 70,
              // paddingBottom: 10,
            }}
          >
            <div
              style={{
                width: '15%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Checkbox checked={item.is_active} />
            </div>
            <div style={{ width: '85%', display: 'flex' }}>
              <div
                style={{
                  width: '60%',
                  display: 'flex',
                  alignItems: 'center',
                }}
                className="staff_leave_type_item"
              >
                {item.name}
              </div>
              <div style={{ width: '40%', paddingLeft: 20 }}>
                <div
                  style={{
                    backgroundColor: `${item.calendar_color}`,
                    width: 30,
                    height: 30,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: `${item.font_color}`,
                    fontSize: 12,
                  }}
                >
                  {item.calendar_code}
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <p style={{ textAlign: 'center', color: '#E4E4E4', marginTop: 20 }}>
          No item
        </p>
      )}


      {data?.length > 0 && (
        <div className="is-flex is-justify-content-center is-align-content-center mt-2 staff_leave_footer">
          <Pagination
            showSizeChanger={false}
            itemRender={itemRender}
            current={currentPage}
            onChange={onChange}
            total={count}
            pageSize={15}
          />
        </div>
      )}
    </div>
  );
};

export default AbsenceTypeTable;
